import ArethusaWrapper from './ArethusaWrapper';

export default ArethusaWrapper;
